<div class="list-pg-inn-sp">
  <div class="list-pg-upro">
    <a (click)="comingSoonAction()"><span
      class="waves-effect waves-light btn-large full-btn list-pg-btn">{{'Contact ADMINS' | translate}}</span></a>
  </div>
</div>
